import { request } from './_request';

export const signin = (props) => {
	const { email, password } = props;
	return (dispatch) => {
		dispatch({ type: 'SIGNIN_LOADING_LOGIN' });

		request
			.post('access/login', { email, password })
			.then((response) => {
				let data = response.data;

				if (!data.error) {
					if (typeof data.result !== 'undefined') {
						localStorage.setItem('@@auth_user', JSON.stringify(data.result));
					}
					dispatch({ type: 'AUTH_USER_LOGIN' });
				} else {


					dispatch({
						type: 'SIGNIN_FAILURE_LOGIN',
						payload: data.message|| 'Usuario o contraseña incorrectas',
						code: data.code
					});
				}
			})
			.catch((e) =>
				dispatch({
					type: 'SIGNIN_FAILURE_LOGIN',
          payload: e.response?.data?.message || 'Usuario o contraseña incorrectas',
					code: typeof e.response !== 'undefined' ? e.response.code : 0
				})
			);
	};
};